if (!customElements.get("blogs-filter")) {
    class BlogsFiltering extends HTMLElement {
        constructor() {
            super();

            this.tagsContainer = this.querySelector('[data-filter="tags"]');
            this.blogContainer = document.querySelector(
                '[data-blogs="main-blogs"]'
            );
            this.paginationContainer = document.querySelector(
                ".pagination, .pagination-load-more"
            );

            if (!this.tagsContainer || !this.blogContainer) return;

            this.onTagClick = this.onTagClick.bind(this);
            this.currentTagState();
        }

        connectedCallback() {
            this.tagsContainer.addEventListener("click", this.onTagClick);
        }

        currentTagState() {
            const path = window.location.pathname;
            if (!path.includes("/tagged/")) return;

            const splitPath = path.split("/");
            const tag = splitPath[splitPath.length - 1];
            const currentActiveTag = tag
                ? document.querySelector('li[data-tag="' + tag + '"]')
                : "";

            this.setActiveTag(currentActiveTag);
        }

        async onTagClick(e) {
            const item = e.target.closest("li[data-tag]");
            if (!item) return;

            e.preventDefault();

            const tagHandle = item.dataset.tag;
            const href = item.children[0].href;
            const url = href;

            await this.loadPage(url);

            history.pushState({ tagHandle }, "", url);
            this.setActiveTag(item);
            this.recallRevealAnimation();
        }

        async loadPage(url) {
            const config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            delete config.headers["Content-Type"];
            delete config.headers["Accept"];

            try {
                const res = await fetch(url, config.headers);
                const text = await res.text();

                const html = new DOMParser().parseFromString(text, "text/html");
                const newArticles = html.querySelector(
                    '[data-blogs="main-blogs"]'
                );
                const newPagination = html.querySelector(
                    ".pagination, .pagination-load-more"
                );

                if (newArticles)
                    this.blogContainer.innerHTML = newArticles.innerHTML;

                if (this.paginationContainer && newPagination) {
                    this.paginationContainer.innerHTML =
                        newPagination.innerHTML;
                }
            } catch (err) {
                console.error("Blog filter AJAX error", err);
            }
        }

        setActiveTag(item) {
            [...this.tagsContainer.children].forEach((li) =>
                li.classList.toggle("active", li === item)
            );
        }

        async recallRevealAnimation() {
            const revealContainer =
                document.querySelectorAll(".reveal-slide-in");
            if (!revealContainer) return;

            typeof onReveal === "function" &&
                (await onReveal?.(revealContainer));
        }

        disconnectedCallback() {
            this.tagsContainer.removeEventListener("click", this.onTagClick);
        }
    }

    customElements.define("blogs-filter", BlogsFiltering);
}
